
String.prototype.toTitleCase = function () {
	const str = this.replace(/-/g, ' ');
	return str.replace(
		/\w\S*/g,
		function (txt) {
			return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
		}
	);
}